import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";
import {
  CloseShiftParameters,
  OpenShiftParameters,
  OpeningShiftCashDto,
  ShiftInfo,
  OpenShiftResult,
  UnCloseShiftParameters,
  ShiftCurrenciesExchangeRateItem,
} from "./ShiftDataModel";

const baseUrl = getApiBaseUrl() + "Shift/";
function GetOpeningShiftCash(posId: string) {
  return axios.get<OpeningShiftCashDto[]>(
    baseUrl + `get-opening-shift-cash/${posId}`,
  );
}

function GetShiftCurrenciesExchangeRate(shiftId: string) {
  return axios.get<ShiftCurrenciesExchangeRateItem[]>(
    baseUrl + `get-shift-cash-currencies-exchangerate/${shiftId}`,
  );
}

function GetShiftInfoById(shiftId: string) {
  return axios.get<ShiftInfo>(baseUrl + `get-shift-info-by-id/${shiftId}`);
}
function GeneratePrintCloseShiftDetailsDocument(shiftId: string) {
  return axios.get<string>(
    baseUrl + `generate-print-close-shift-details-document/${shiftId}`,
  );
}

function GeneratePrintShiftSummaryDocument(shiftId: string) {
  return axios.get<string>(
    baseUrl + `generate-print-shift-summary-document/${shiftId}`,
  );
}

function GetShiftInfo(posId: string) {
  return axios.get<ShiftInfo>(baseUrl + `get-shift-info/${posId}`);
}
function ValidateShift(posId: string) {
  return axios.get<OpenShiftResult>(baseUrl + `validate-shift/${posId}`);
}
function OpenShift(parameters: OpenShiftParameters) {
  return axios.post<OpenShiftResult>(
    baseUrl + "open-shift",
    {
      parameters: parameters,
    },
    {
      idempotent: true,
      idempotencyGroup: "open-shift",
    },
  );
}
function CloseShift(parameters: CloseShiftParameters) {
  return axios.post<boolean>(
    baseUrl + "close-shift",
    {
      parameters: parameters,
    },
    {
      idempotent: true,
      idempotencyGroup: "close-shift",
    },
  );
}
function UnCloseShift(parameters: UnCloseShiftParameters) {
  return axios.post<boolean>(
    baseUrl + "unclose-shift",
    {
      parameters: parameters,
    },
    {
      idempotent: true,
      idempotencyGroup: "unclose-shift",
    },
  );
}
const shiftAPI = {
  GetOpeningShiftCash,
  GetShiftCurrenciesExchangeRate,
  GetShiftInfo,
  OpenShift,
  CloseShift,
  UnCloseShift,
  ValidateShift,
  GetShiftInfoById,
  GeneratePrintCloseShiftDetailsDocument,
  GeneratePrintShiftSummaryDocument,
};

export default shiftAPI;
